module.exports = {
  strings: {
    pluginNameGoogleDrive: 'Google Drive'
  }
};